module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-18.d8b248f7.png";